import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import DateInput from "components/Input/DateInput.js";
import { TextInput } from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { createBillEtatPaiement, downloadFile } from "services/ConfigServices";

import { etats } from "variables/bills";
import { naturebudgetaire } from "variables/lists/bills";

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataMargin = styled.div`
font-size: 14px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
  margin-top: 10px;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;



function EditEtatPaiementDialog(props) {
  const { closeModal, bill } = props;

  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [budgnature, setBudgnature] = useState("");
  const [billnumber, setBillnumber] = useState(bill.docreference);
  const [billdate, setBilldate] = useState(bill.billdate && moment(bill.billdate).isValid()
    ? moment(bill.billdate).format("YYYY-MM-DD")
    : "");
  const [intitule, setIntitule] = useState("");
  const [marketnumber, setMarketnumber] = useState("");

  const [file, setFile] = useState(null);

  const handleBudgnatureChange = (event) => { setBudgnature(event.target.value); };
  const handleBillnumberChange = (event) => { setBillnumber(event.target.value); };
  const handleBilldateChange = (event) => { setBilldate(event.target.value); };
  const handleIntituleChange = (event) => { setIntitule(event.target.value); };
  const handleMarketnumberChange = (event) => { setMarketnumber(event.target.value); };


  const downloadGED = (fileId, fileName) => async () => {
    axios
      .get(
        downloadFile(fileId),
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };


  const classes = useStyles();

  useEffect(() => {
    if (bill) {
      let budgnature = naturebudgetaire.find((x) => x.id == bill.energy).name;
      setBudgnature(budgnature);
    }
  }, [bill]);

  useEffect(() => {
    if (!budgnature || !billnumber || !billdate || !intitule || !marketnumber)
      setButtonDisabled(true)
    else
      setButtonDisabled(false);
  }, [budgnature, billnumber, billdate, intitule, marketnumber]);

  const handleSubmit = async (event) => {
    console.log(bill);
    let billautoids = bill.pdlBills.map((option, index) => (
      option.id
    ))

    let billobj = {
      billautoids,
      budgnature,
      billnumber,
      billdate,
      intitule,
      marketnumber
    };

    createEtat(event, billobj);
  };

  const createEtat = async (event, billobj) => {
    console.log(billobj);
    setButtonDisabled(true);
    await axios
      .post(
        createBillEtatPaiement(),
        billobj,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        setButtonDisabled(false);
        if (res.status == 200) {
          setNotification("success", "Etat de paiement créé");
          console.log(res.data);
          setFile(res.data);
        } else setNotification("error", "Une erreur est survenue ici");
      })
      .catch((error) => {
        console.log(error);
        setNotification("error", "Une erreur est survenue là");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  console.log(file);
  return (
    <>
      <form className={classes.root}>
        {bill &&
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div>
                <TextInput
                  isRequired
                  inputTitle={etats.budgnature}
                  textInput={budgnature}
                  handleTextInputChange={handleBudgnatureChange}
                />
              </div>
              <div>
                <TextInput
                  isRequired
                  inputTitle={etats.billnumber}
                  textInput={billnumber}
                  disabled
                  handleTextInputChange={handleBillnumberChange}
                />
              </div>
              <div>
                <DateInput
                  isRequired
                  inputTitle={etats.billdate}
                  dateInput={billdate}
                  disabled
                  handleDateInputChange={handleBilldateChange}
                />
              </div>
              <div>
                <TextInput
                  isRequired
                  inputTitle={etats.intitule}
                  textInput={intitule}
                  handleTextInputChange={handleIntituleChange}
                />
              </div>
              <div>
                <TextInput
                  isRequired
                  inputTitle={etats.marketnumber}
                  textInput={marketnumber}
                  handleTextInputChange={handleMarketnumberChange}
                />
              </div>
              <Button
                disabled={buttonDisabled}
                className={
                  buttonDisabled
                    ? classes.submitButtonDisabled
                    : classes.submitButton
                }
                onClick={() => {
                  handleSubmit();
                }}
              >
                Télécharger
              </Button>

              {
                file &&
                <DataContainer>
                  <Data>{"Fichier créé"}</Data>
                  <DataResultLink onClick={downloadGED(file.fileId, file.fileName)}>
                    {file.fileName}
                  </DataResultLink>
                </DataContainer>
              }
            </GridItem>

          </GridContainer>}
      </form>
    </>
  );
}

export default EditEtatPaiementDialog;
